import { Icon } from "../../components/BaseComponents/Icon";

export const ArrowLeftIcon = (props) => (
	<Icon fill="none" {...props}>
		<path
			fill="currentColor"
			d="M8.3 4.3a1 1 0 1 1 1.4 1.4L4.42 11H22a1 1 0 1 1 0 2H4.41l5.3 5.3.07.07a1 1 0 0 1-1.41 1.4l-.08-.06-7-7a1.01 1.01 0 0 1-.25-.42l-.01-.05a1 1 0 0 1 0-.47l.01-.06a.99.99 0 0 1 .13-.26 1 1 0 0 1 .12-.16l7-7Z"
		/>
	</Icon>
);
